import React from 'react';
import { connect } from 'react-redux'
import {
  accounts_index
} from '../actions'
import { Redirect } from 'react-router-dom'

import {
  is_logged_on,
  is_validating
 } from "../helpers"

import Loading from './Loading';
import Pagination from './Pagination'
import AccountRow from './AccountRow'
import AccountFilters from './AccountFilters'

const mapStateToProps = state => {
  return {
    current_user: state.auth.current_user.data,
    accounts: state.account.accounts,
    pagination: state.account.pagination,
    fetching: state.account.fetching
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getAccounts: (page, filters) => { dispatch( accounts_index(page, filters) ) }
  }
}

class ConnectedAccounts extends React.Component {
  constructor() {
    super()
    this.state={
      nowEditing: null,
      filters: {}
    }
  }

  componentDidMount() {
    this.getAccounts()
  }

  getAccounts(page = 1) {
    const {filters} = this.state
    this.props.getAccounts(page, filters)
  }

  initEdit(id) {
    this.setState({
      nowEditing: id
    })
  }

  setFilters(filters) {
    this.setState({filters: filters})
    this.props.getAccounts(1, filters)
  }

  render () {
    const { accounts, current_user, pagination, fetching } = this.props
    const { filters } = this.state

    if ( ( !is_validating() && !is_logged_on() ) ) {
      return <Redirect to="/" />
    }

    if ( !is_validating() && current_user.role !== "admin" ) {
      window.M.toast({
        html: "Insufficient priviledges"
      })
      return <Redirect to="/" />
    }

    if ((fetching && accounts.length === 0 && Object.keys(filters).length === 0) || typeof(pagination) === "undefined") {
      return (
       <Loading />
      )
    }

    return (
      <div className="collection with-header">
        <div className="collection-header red darken-1 white-text">
          <span className="flow-text">Accounts List</span>
          <i className="material-icons right">menu</i>
        </div>

        <AccountFilters setFilters={this.setFilters.bind(this)} filters={this.state.filters}/>

        <table className="bordered striped highlight responsive-table users-list">
          <thead>
            <tr>
              <th>Account</th>
              <th>Status</th>
              <th>Users</th>
              <th>Projects</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {
                accounts.map(function(item){
                return (
                  <AccountRow current_user={this.props.current_user} account={item}
                      initEdit={this.initEdit.bind(this)} currentEdit={this.state.nowEditing}
                      page={pagination.page} key={item.id}
                  />
                )
              }, this)
            }
          </tbody>
        </table>
        <Pagination pagination={pagination} fetchPage={this.getAccounts.bind(this)}/>
      </div>
    )
  }
}

const Accounts = connect(mapStateToProps, mapDispatchToProps)(ConnectedAccounts)

export default Accounts



// WEBPACK FOOTER //
// ./src/js/components/Accounts.js